import type { HubSpotFormProps } from 'js/src/components/common/email-capture/HubSpotForm';

export type EmailCaptureForm = Pick<HubSpotFormProps, 'portalId' | 'formId' | 'region'>;

export const PRODUCT_UPDATES_FORM: EmailCaptureForm = {
    portalId: '4012735',
    formId: '0f2ac958-170e-466e-8d22-bc536a22fd6a',
    region: 'na1',
};

export const PRODUCT_UPDATES_MESSAGE =
    'Sign up to receive Product updates and never miss a new feature launch again!';
